/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable radix */
/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import Utils from 'Utils/utils';
import LoadingWrapper from 'Components/common/loadingWrapper';
import makeApi, { URLS } from 'Utils/apiUtil';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';
import seekerSampleCsvFile from '../../../assets/csv/Seeker_Sample_File.csv';

class SeekerNewListState {
  @observable showPopup = false;

  @observable callBack;

  @action
  setShowPopup = val => {
    this.showPopup = val;
  };

  @action
  setCallback = val => {
    this.callBack = val;
  };
}
const seekerNewListState = new SeekerNewListState();

const SeekerNewListPopup = observer(props => {
  const [fileError, setFileError] = React.useState('');
  const [fileNameError, setFileNameError] = React.useState('');
  const [fileData, setFileData] = React.useState('');
  const [fileName, setFileName] = React.useState('');
  const [fileUpload, setFileUpload] = React.useState(true);
  const [showLoading, setShowLoading] = React.useState(false);
  const onInputChange = e => {
    setFileNameError('');
    const inputVal = e.currentTarget.value;
    setFileName(inputVal);
  };

  const onFileChange = async e => {
    // const event = e;
    debugger;
    const callBack = data => {
      console.log('seeker ', data);
      debugger;
      setFileData('');
      setFileError('');
      if (!data) {
        setFileError('Empty file');
        console.log('empty file', data);
      } else if (data !== '' && data === 'error') {
        setFileError('Maximum allowed limit is 25000 entries');
        console.log('max length error', data);
      } else {
        console.log('data ', data);
        setFileData(data);
      }
      setTimeout(function() {
        setFileUpload(false);
      }, 0);
      setTimeout(function() {
        setFileUpload(true);
      }, 50);
    };
    Utils.uploadCsv(e, callBack, true);
    // event.target.value = '';
  };

  const onFileUpload = e => {
    if (fileName === '') {
      setFileNameError('Required');
    } else if (fileData === '') {
      setFileError('Required');
    } else {
      const postData = {
        listName: fileName,
        input: fileData.entries,
      };
      const config = {
        url: URLS.seekerBulkJobUpload,
        method: 'POST',
        data: postData,
      };
      setShowLoading(true);
      makeApi(config)
        .then(response => {
          debugger;
          console.log('onFileUpload ', response);
          // thisObj.resultLoading = false;
          setShowLoading(false);
          if (response && response.status === 200)
            seekerNewListState.callBack();
        })
        .catch(error => {
          setShowLoading(false);
          console.log('setOwnershipData error ', error);
        });
    }
  };

  React.useEffect(() => {
    setFileError('');
    setFileNameError('');
    setFileData('');
    setFileName('');
    setFileUpload(true);
    setShowLoading(false);
  }, [seekerNewListState.showPopup]);

  return seekerNewListState.showPopup ? (
    <>
      <div className="export-type-popup seeker-new-list common-popup">
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => seekerNewListState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>
          <LoadingWrapper show={showLoading} />
          <div className="title">New List</div>

          <div className="popup-content-wrap">
            <div className="newListCont">
              <div className="innerCont">
                <div className="listNameCont">
                  <input
                    required
                    className="input-box"
                    name="csvListName"
                    type="text"
                    id="csvListName"
                    placeholder="List Name"
                    value={fileName}
                    onChange={onInputChange}
                  />

                  <div
                    className={`file-error ${
                      fileNameError !== '' ? ' showError' : ''
                    }`}
                  >
                    {fileNameError || '&bnsp;'}
                  </div>
                </div>
                <div className="csvUploadFile">
                  <div className="csvUploadWrap">
                    <input
                      type="input"
                      id="csvUploadInput"
                      className="input-box"
                      name="csvUploadInput"
                      required
                      placeholder="File Name"
                      defaultValue={fileData !== '' ? fileData.fname : ''}
                      readOnly
                    />
                    {fileUpload && (
                      <div className="chooseFileBtnCont">
                        <span className="btnTxt">Choose File</span>
                        <input
                          type="file"
                          accept=".csv,text/csv"
                          id="uploadFile"
                          onChange={onFileChange}
                          required
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className={`file-error ${
                      fileError !== '' ? ' showError' : ''
                    }`}
                  >
                    {fileError || '&nbsp;'}
                  </div>
                </div>
                <div className="upload-btn-wrap">
                  <div className="upload-btn" onClick={onFileUpload}>
                    upload
                  </div>
                </div>
                <div className="sample-doc-text">
                  <div className="info-text">
                    The CSV should contain the first name, last name and domain
                    in the first three columns.&nbsp;
                    <a className="sample-csv" href={seekerSampleCsvFile}>
                      Click here
                    </a>
                    &nbsp; to download a sample file.
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="popup-action-wrap">
            <div
              className="popup-action-btn positive-btn"
              onClick={confirmClick}
            >
              Upload
            </div>
          </div> */}
        </div>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => seekerNewListState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export { SeekerNewListPopup, seekerNewListState };
export default SeekerNewListPopup;
